import {
  AgxColumn,
  AgxTypography,
  AgxRow,
  AgxDivider,
  PaddingProp,
} from '@urbanx/agx.ui-components2'
import './panel.scss'
import { JSX, ReactNode, useMemo } from 'react'
import clsx from 'clsx'

interface PanelProps {
  children: JSX.Element | ReactNode
  title?: string | ReactNode
  actionContent?: JSX.Element
  halfWidth?: boolean
  padding?: PaddingProp
}

const Panel = ({
  children,
  title,
  actionContent,
  halfWidth,
  padding,
}: PanelProps) => {
  const classes = useMemo(() => {
    return clsx('panel', halfWidth && 'container50Percent')
  }, [halfWidth]);

  return (
    <div className={classes}>
      <AgxColumn  alignItems="flex-start" fill>
        {(title || actionContent) && (
          <>
            <AgxRow
              fill
              
              alignItems="flex-start"
              padding={
                padding
                  ? padding
                  : {
                      top: actionContent ? 'spacing-lg' : 'spacing-2xl',
                      bottom: actionContent ? 'spacing-lg' : 'spacing-2xl',
                      left: 'spacing-xl',
                      right: 'spacing-xl',
                    }
              }
            >
              <AgxRow
                fill
                
                justifyContent="space-between"
                alignItems="alignCenter"
              >
                {typeof title === 'string' ? (
                  <AgxTypography id="panel" type="title" size="medium">
                    {title}
                  </AgxTypography>
                ) : (
                  title
                )}
                {actionContent && actionContent}
              </AgxRow>
            </AgxRow>
            <AgxDivider variant="horizontal" />
          </>
        )}
        <AgxColumn
          gap="spacing-xl"
          alignItems="flex-start"
          fill
          padding={
            padding
              ? padding
              : { top: 'spacing-xl', bottom: 'spacing-xl', left: 'spacing-xl', right: 'spacing-xl' }
          }
        >
          {children}
        </AgxColumn>
      </AgxColumn>
    </div>
  )
}

export default Panel
